import React, {Component} from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {faExclamationCircle} from '@fortawesome/fontawesome-free-solid';
import './offline.scss';

export class Offline extends Component {
    constructor(props) {
        super(props);

        this.state = {
            offline: false
        }

        this.offline();
        this.online();
    }

    offline() {
        window.addEventListener('offline', () => {
            this.setState({offline: true});
        });
    }

    online() {
        window.addEventListener('online', () => {
            this.setState({offline: false});
        });
    }

    render() {
        return (
            <div id="offlineNotification" className={`${!this.state.offline ? 'hide':''}`}>
                <FontAwesomeIcon icon={faExclamationCircle}/>&nbsp;החיבור לאינטרנט אבד
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/App/Offline.jsx